import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function ClosingCTASection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-92">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(34,197,94,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-93" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-95">
          <p className="text-xl text-gray-400 mb-8 leading-relaxed" data-id="element-96">
            Hay algo que cambia cuando empezás a producir tu comida:
          </p>

          <div className="space-y-3 mb-10" data-id="element-97">
            {['Sentís control.', 'Sentís calma.', 'Sentís independencia.'].map((line, i) => <motion.p key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + i * 0.15,
            duration: 0.5
          }} className="text-3xl md:text-4xl font-black text-white" data-id="element-98">
                  {line}
                </motion.p>)}
          </div>

          <p className="text-lg text-gray-400 mb-4" data-id="element-99">
            Y lo mejor es que no necesitás "saber de huerta".{' '}
            <span className="text-white font-bold" data-id="element-100">Necesitás un sistema.</span>
          </p>

          <p className="text-xl font-bold text-white mb-10" data-id="element-101">
            Huerta Productiva 360° ya está armado para vos.
          </p>

          <p className="text-gray-400 mb-6" data-id="element-102">
            Más de 800 personas ya están cosechando con este sistema.
          </p>

          <motion.div whileInView={{
          scale: [0.95, 1.02, 1]
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-103">
            <Button size="xl" onClick={scrollToCheckout} className="group text-xl px-12 py-6" data-id="element-104">
              SÍ, QUIERO MI HUERTA 360°
              <ArrowDown className="ml-3 w-6 h-6 group-hover:translate-y-1 transition-transform" data-id="element-105" />
            </Button>
          </motion.div>

          <p className="mt-6 text-zinc-600 text-sm" data-id="element-106">
            Descarga inmediata · Pago seguro con Mercado Pago · Garantía 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}